import { Lightning } from '@lightningjs/sdk';
import { DEFAULT_MODE, PRIMARY, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { SCREEN_WIDTH, SCREEN_HEIGHT, getScreenSize, identity } from '../tornado/utils/sizes';

export const defaultContext = { screenSize: getScreenSize(), colorMode: DEFAULT_MODE };

export const { screenSize = FULL_HD } = defaultContext;

const colors = {
  background: makeThemeColor(TERTIARY),
  text: makeThemeColor(PRIMARY),
  border: makeThemeColor(PRIMARY, 0.3),
};

const CONTENT_PADDING_TOP = {
  [HD]: 24,
  [FULL_HD]: 36,
};

const CONTENT_PADDING_LEFT = {
  [HD]: 372,
  [FULL_HD]: 698,
};

const QR_CODE_WRAPPER_PADDING_TOP = {
  [HD]: 120,
  [FULL_HD]: 202,
};
const QR_CODE_WRAPPER_SIZE = {
  [HD]: {
    w: 452,
    h: 422,
  },
  [FULL_HD]: {
    w: 580,
    h: 598,
  },
};

const QR_CODE_TITLE_PADDING_TOP = {
  [HD]: 48,
  [FULL_HD]: 64,
};
const QR_CODE_IMAGE_PADDING_TOP = {
  [HD]: 40,
  [FULL_HD]: 64,
};

export const QR_CODE_IMAGE_SIZE = {
  [HD]: {
    w: 162,
    h: 162,
  },
  [FULL_HD]: {
    w: 250,
    h: 250,
  },
};

const QR_CODE_INFO_PADDING_TOP = {
  [HD]: 40,
  [FULL_HD]: 56,
};

export const PAGE_TITLE_FONT = {
  [HD]: FONT.OTTAWA_3,
  [FULL_HD]: FONT.PARIS_3,
};

export const QR_TITLE_FONT = {
  [HD]: FONT.KINSHASA_3,
  [FULL_HD]: FONT.KINSHASA_3,
};

export const INFO_WRAP_WIDTH = {
  [HD]: 388,
  [FULL_HD]: 485,
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize = FULL_HD, colorMode = DEFAULT_MODE } = context;

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Background: {
      rect: true,
      h: identity,
      w: identity,
      color: colors.background[colorMode],
    },
    Content: {
      x: CONTENT_PADDING_LEFT[screenSize],
      y: CONTENT_PADDING_TOP[screenSize],
      flex: {
        direction: 'column',
        alignItems: 'center',
      },
      PageTitle: {
        text: {
          ...getFont(PAGE_TITLE_FONT[screenSize], screenSize),
          verticalAlign: 'middle',
          textColor: colors.text[colorMode],
        },
      },
      QRCodeWrapper: {
        flex: {
          direction: 'column',
          alignItems: 'center',
        },
        y: QR_CODE_WRAPPER_PADDING_TOP[screenSize],
        texture: Lightning.Tools.getRoundRect(
          QR_CODE_WRAPPER_SIZE[screenSize].w,
          QR_CODE_WRAPPER_SIZE[screenSize].h,
          8,
          colors.border[colorMode] ? 1 : 0,
          colors.border[colorMode],
          true,
          colors.background[colorMode],
        ),
        Title: {
          flexItem: { marginTop: QR_CODE_TITLE_PADDING_TOP[screenSize] },
          text: {
            ...getFont(QR_TITLE_FONT[screenSize], screenSize),
            verticalAlign: 'middle',
            textColor: colors.text[colorMode],
          },
        },
        Code: {
          flexItem: { marginTop: QR_CODE_IMAGE_PADDING_TOP[screenSize] },
          rect: true,
          h: QR_CODE_IMAGE_SIZE[screenSize].h,
          w: QR_CODE_IMAGE_SIZE[screenSize].w,
          color: colors.text[colorMode],
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: 8,
            strokeColor: colors.text[colorMode],
          },
        },
        Info: {
          flexItem: {
            marginTop: QR_CODE_INFO_PADDING_TOP[screenSize],
          },
          text: {
            ...getFont(FONT.BERLIN_1, screenSize),
            maxLines: 3,
            verticalAlign: 'middle',
            wordBreak: true,
            advancedRenderer: true,
            wordWrapWidth: INFO_WRAP_WIDTH[screenSize],
            textAlign: 'center',
            textColor: colors.text[colorMode],
          },
        },
      },
    },
  };
};
